exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_SocialGalleryDownloader_2vfTfF8nS9uBhq-7pXO8lh {\n  height: 125px;\n  width: 300px;\n  border-radius: 5px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  padding: 10px;\n  text-align: center;\n}", ""]);

// Exports
exports.locals = {
	"IA_SocialGalleryDownloader": "IA_SocialGalleryDownloader_2vfTfF8nS9uBhq-7pXO8lh"
};